module.exports = {
    EXTERNAL_TRANSFER_FUND_POST_CONFIRMATION_ERROR : 'EXTERNAL_TRANSFER_FUND_POST_CONFIRMATION_ERROR',
}
